/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
import { useDispatch, useSelector } from 'react-redux';
import React, { useState } from 'react';
import {
    SearchByFilters,
    SearchByFiltersCustom,
    SimpleSearch,
    SimpleSearchWithId
} from '../../../../../reduxToolkit/Search/SearchApi';
import {
    CRITERIA_MODEL, DEFAULT_LEFT,
    LEFT_FIRST_COLUMN_WITH_CHECKBOX,
    SEARCH_MODEL
} from "../../../../../components/table/Model/TableModel";
import {useNavigate} from "react-router-dom";
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import {EMPTY_VALUES} from "../../../../../Apis/functions";
import CustomChip from "../../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status} from "../../../../../enums/statusEnum";
import routes from "../../../../../Routes/routes";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import {permissionObj} from "../../../../../Helpers/permission";
import TableFunction from "../../../../../components/table/TableFunction";
import {
    DetailsIconsOptions,
    IconDocumentation, UpdateIconsOptions
} from "../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../components/CustomTooltip";

const MainVehiclesTableApp = ({
    view,
    selectedList,
    setSelectedList,
    option,
    setBodyForExport,
    searchElement,
    finalArray,
    setIsAllChecked,
    setCriteria,
    modified,
    setModified,
    showActionsContractorSupplier
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [results, setResults] = useState({ content: [], totalElements: 0 });
    const tableId = "tbl_mvt_vehicle";
    const searchId = "txt_mvt_search_vehicle";
    const deletePermission =   contractorId  || supplierId || DEV || permission?.includes(permissionObj?.WEB_VEHICLE_DELETE);
    const leftPosition = deletePermission ? LEFT_FIRST_COLUMN_WITH_CHECKBOX : DEFAULT_LEFT;
    // Contractors and suppliers get the actions column while their profile is active or the row has a period,
    // employees need the update permission
    const showColumnsButtons = (contractorId || supplierId)
        ? (showActionsContractorSupplier || results?.content?.some((item) => item?.periodId) || DEV
            || permission?.includes(permissionObj?.WEB_VEHICLE_UPDATE))
        : (DEV || permission?.includes(permissionObj?.WEB_VEHICLE_UPDATE)
            || permission?.includes(permissionObj?.WEB_VEHICLE_READ));


    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head">{t('brand')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('sub_brand')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('model')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('color')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('plates')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('vin')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('serial_number')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('status')}</CustomTh>
        ];
    }

    const getTbody = () => {
        if (!results || results?.content?.length === 0)
            return {
                body: [],
                data: []
            };

        const body = results?.content?.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={"first-column"}>
                        <CustomTooltip
                            text={item?.brand}
                            classes={`fs-14px font-color-general-950 text-ellipsis`}
                            showIfTruncated={true}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomTooltip
                            text={item?.subBrand}
                            classes={`fs-14px font-color-general-950 text-ellipsis`}
                            showIfTruncated={true}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>{item?.model}</CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomTooltip
                            text={item?.color}
                            classes={`fs-14px font-color-general-950 text-ellipsis`}
                            showIfTruncated={true}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomTooltip
                            text={item?.plate}
                            classes={`fs-14px font-color-general-950 text-ellipsis`}
                            showIfTruncated={true}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomTooltip
                            text={item?.vin || EMPTY_VALUES.DEFAULT}
                            classes={`fs-14px font-color-general-950 text-ellipsis`}
                            showIfTruncated={true}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomTooltip
                            text={item?.serialNumber || EMPTY_VALUES.DEFAULT}
                            classes={`fs-14px font-color-general-950 text-ellipsis`}
                            showIfTruncated={true}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={statusColor[item?.statusId]}
                            fontColor={statusFontColor[item?.statusId]}
                            borderColor={statusBorderColor[item?.statusId]}
                            legend={t(status[item?.statusId]) || EMPTY_VALUES.DEFAULT}
                            variant='large'
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body,
            data: results?.content
        }
    };

    const handleOnClickUpdate = (contractorId, supplierId, item) => {
        const id = item?.vehicleId || item?.id;
        if (contractorId) {
            navigate(`${routes.vehicleContractor.update}${id}`);
        } else if (supplierId) {
            navigate(`${routes.vehicleSupplier.update}${id}`)
        } else {
            navigate(`${routes.vehicleFleet.update}${id}`);
        }
    }

    const getActionsButtons = (item, index) => {
        const id = item?.vehicleId || item?.id;
        const showButtons = ((contractorId || supplierId) && (showActionsContractorSupplier || item?.periodId))
            || DEV || permission?.includes(permissionObj?.WEB_VEHICLE_UPDATE)
            || permission?.includes(permissionObj?.WEB_VEHICLE_READ);

        if (!showButtons) return null;

        return (
            <>
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${id}`}
            >
                {( showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_VEHICLE_UPDATE)) &&
                <DropDownMenuItem
                    index={index}
                    handleClose={handleClose}
                    name={t("update")}
                    icon={<UpdateIconsOptions/>}
                    click={()=>{
                        handleOnClickUpdate(contractorId, supplierId, item);
                    }}
                />
                }

                { (showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_VEHICLE_READ)) &&
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t("details")}
                        icon={<DetailsIconsOptions />}
                        click={() => {
                            if (contractorId) {
                                navigate(routes.vehicleContractor.details + `${id}`,
                                    {state: {backUrl: routes.vehicleContractor.search}});
                            }
                            else if (supplierId) {
                                navigate(routes.vehicleSupplier.details + `${id}`,
                                    {state: {backUrl: routes.vehicleSupplier.list}});
                            }
                            else {
                                navigate(routes.vehicleFleet.details + `${id}`,
                                    {state: {backUrl: routes.vehicleFleet.list}});
                            }
                        }}
                    />
                }

                { ((contractorId || supplierId) && item?.periodId) &&
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('documentation')}
                        icon={<IconDocumentation />}
                        click={() => {
                            if (contractorId) {
                                navigate(routes.contractor.vehicleDocumentation + `${id}`,
                                    {state: {backUrl: routes.vehicleContractor.search,}});
                            } else if (supplierId) {
                                navigate(routes.suppliers.vehicleDocumentation + `${id}`,
                                    {state: {backUrl: routes.suppliers.vehicleFleet,}});
                            }
                        }}
                    />
                }

            </DropDownMenuProfile>
        </>
        );
    }

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const userId = contractorId ?? supplierId ?? null;
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            view,
            key: searchElement,
            model: option,
            ...(userId && { userId }),
        });
        setBodyForExport(body);
        const action = userId ? SimpleSearchWithId : SimpleSearch;
        dispatch(action({ body })).then(({ payload: { data: { data, success } } }) => {
            if (success) setResults(data);
        });
    }

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page) => {
        const userId = contractorId ?? supplierId ?? null;
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            rootGroup: CRITERIA_MODEL.set(finalArray),
            ...(userId && { userToFindId: userId }),
        });
        setCriteria(body);
        const action = userId ? SearchByFiltersCustom : SearchByFilters;
        dispatch(action({ option, body })).then(({ payload: { data: { data, success } } }) => {
            if (success) setResults(data);
        });
    }

    const {
        t,
        thead,
        tbody,
        handleCheckboxChange,handleDeleteAll,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        getThead,
        getTbody,
        labelRowsPerPage: 'vehicle_per_page',
        setIsAllChecked,
        view,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advanced search
        finalArray,//New - apply only with advanced search
    });

    return {
        DEV,
        contractorId,
        supplierId,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        setResults,
        rowsPerPage,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        pagination,
        deletePermission,
        navigate,
        t,
        showColumnsButtons
    }

}

export default MainVehiclesTableApp;
